// src/pages/MainPage.tsx
import React, { useEffect } from 'react';
import ImgMain from '@/assets/app/images/main/main_1.png';
import { useNavigate } from 'react-router';
import useAppAuthStore from '@/shared/store/UseAppAuthStore';
import useAppStore from '@/shared/store/UseAppStore';

/**
 * 메인 페이지
 * - 캐릭터 선택 화면
 * - Tailwind CSS 사용
 */
const MainPage: React.FC = () => {
  const { setIsShowBottomNavigation, setIsShowProfileHeader } = useAppStore();
  const navigate = useNavigate();

  const handleRecruitStart = () => {
    // 모집 시작 로직
    navigate('/adventure');
  };

  useEffect(() => {
    setIsShowBottomNavigation(true);
    setIsShowProfileHeader(true);
  }, []);

  return (
    <>
      <div className="relative min-h-[520px] flex m0 items-center flex-col">
        {/* 무지개 배경 */}
        <img src={ImgMain} style={{ width: '324px', height: 'auto' }} />
        <button
          onClick={handleRecruitStart}
          className="block f-one-pop w-[calc(100%-48px)] pt-[6px] pb-[2px] bg-[#0094EF] rounded-[25px] border-b-[5px] border-b-[#0070D6] text-white text-[25px] font-bold -[25px] cursor-pointer transition-all duration-200 active:scale-[0.98]"
        >
          모험시작
        </button>
      </div>

      {/* 모집 시작 버튼 */}
    </>
  );
};

export default MainPage;
